import { connect } from 'react-redux';
import { logger } from '@fiverr-private/obs';
import { reportBusinessFilterEvent, TYPES } from '../../../../utils/reports/filter/businessFilter';
import { toggleBusiness } from '../../../../store/actions';
import Business from './Business';

const mapStateToProps = ({ filters_counters: { business } = 0, businessChecked }) => ({
    businessChecked,
    filterCount: business,
});

const mapDispatchToProps = (dispatch) => ({
    onToggle: (value) => {
        const checked = value.target.checked;
        dispatch(toggleBusiness(checked))
            .then((eventData) => {
                const type = checked ? TYPES.business.onClick : TYPES.business.offClick;

                reportBusinessFilterEvent(type, { ...eventData });
            })
            .catch((error) => {
                logger.error(error, {
                    func: 'onToggle',
                    component: 'Business',
                });
            });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Business);
